import { isValidEmail } from 'platform/forms/validations';
import { createConfirmPrefill, prefillValue } from './shared';

export const CONTACT_INFO_CONFIRM_KEY = 'view:sponsorContactInfoIsCorrect';

export const getProfilePrefillPhone = prefillValue('phone');
export const getProfilePrefillEmail = prefillValue('email');

// matches the edit page so a confirmed value can't fail hidden validation
const isValidPhone = phone => /^\d{10}$/.test(phone ?? '');

export const hasProfileContactInfoPrefill = formData =>
  isValidPhone(getProfilePrefillPhone(formData)) &&
  isValidEmail(getProfilePrefillEmail(formData) ?? '');

export const {
  showPrefill: showSponsorContactInfoPrefill,
  showEntry: showSponsorContactInfoEntry,
  sync: syncSponsorContactInfoPrefill,
} = createConfirmPrefill({
  appliedKey: 'view:sponsorContactInfoPrefillApplied',
  confirmKey: CONTACT_INFO_CONFIRM_KEY,
  hasPrefill: hasProfileContactInfoPrefill,
  fields: {
    sponsorPhone: getProfilePrefillPhone,
    sponsorEmail: getProfilePrefillEmail,
  },
});
